import DataTable from "datatables.net-react";
import $ from 'jquery';
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { TradeLogServices } from "../../services/TradeLogServices";
import * as BullCache from "../../util/BullCache";
import AdminDropdown from "../components/AdminDropdown";
import BrokerDropdown from '../components/BrokerDropdown';
import ClientDropdown from '../components/ClientDropdown';
import From from '../components/From';
import MarketDropdown from '../components/MarketDropdown';
import MasterDropdown from '../components/MasterDropdown';
import ScriptDropdown from '../components/ScriptDropdown';
import To from '../components/To';
import '../custom.css';

function Tradelog() {

  const [loading, setLoading] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [selectedBroker, setSelectedBroker] = useState(null);
  const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedMarket, setSelectedMarket] = useState(null);
  const [selectedScript, setSelectedScript] = useState(null);
  const [data, setData] = useState([]);
  const [status, setStatus] = useState('UPDATE');
  const [selectedBrokerId, setSelectedBrokerId] = useState(null);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [selected, setSelected] = useState('');
  const [calledFirstTime, setCalledFirstTime] = useState(false);


  var user = BullCache.getFromCache("user");
  var allScripts = BullCache.getFromCache('allScripts');

  useEffect(() => {
    if (fromDate && toDate && !calledFirstTime) {
      const dataToSubmit = {
        adminId: user.adminId,
        status,
        segment: selectedMarket,
        keyword: selectedScript,
        date: fromDate,
        endDate: toDate,
      };
      setCalledFirstTime(true);
      fetchData(dataToSubmit);
      
    }
  }, [fromDate, toDate]);


  const fetchData = (dataToSubmit) => {
    setLoading(true);
    TradeLogServices.getTableData(dataToSubmit)
      .then((resp) => {
        setLoading(false);
        if (resp.code === 1 && resp.data.trades.length > 0) {
          setData(resp.data.trades);
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching trade data:', error);
      });
  };



  const handleMarketChange = (market) => {
    setSelectedMarket(market);
  };

  const handleScriptChange = (script) => {
    setSelectedScript(script);
  };

  const handleSelectedClientChange = (selected) => {
    setSelectedClient(selected?.userId);
  };

  const handleFromDateChange = (newDate) => {
    setFromDate(newDate);
  };
  const handleToDateChange = (newDate) => {
    setToDate(newDate);
  };
  const handleScriptReset = () => {
    setSelectedScript(null);
  };
  function handleChange(e) {
    const { id } = e.target;
    setSelected(id);
  }

  useEffect(() => {
      setCalledFirstTime(true);
      handleSubmit();
  }, [status]);
  
  const handleReset = () => {
    
    setSelectedMarket( null );
    setSelectedScript(null);
    setSelectedAdmin(null);
    setSelectedMaster(null);
    setSelectedBrokerId(null);
    setSelectedSubBrokerId(null);
    setSelectedClient(null);

  };

  const handleSubmit = () => {
    setLoading(true);
    const dataToSubmit = {
      adminId: user.adminId,
      status: status,
      keyword: selectedScript,
      segment: selectedMarket,
      date: fromDate,
      endDate: toDate
    };

    if (selectedClient) {
      dataToSubmit.userId = selectedClient;
      dataToSubmit.adminId = user.adminId;
    } else if (selectedSubBrokerId) {
      dataToSubmit.adminId = selectedSubBrokerId.value;
    } else if (selectedBrokerId) {
      dataToSubmit.adminId = selectedBrokerId;
    } else if (selectedMaster) {
      dataToSubmit.adminId = selectedMaster.value;
    } else if (selectedAdmin) {
      dataToSubmit.adminId = selectedAdmin.value;
    }
    
    TradeLogServices.getTableData(dataToSubmit)
      .then((resp) => {
        setLoading(false);
        if (resp.code === 1) {
          if (resp.data.logList.length > 0) {
            setData(resp.data.logList);
          }
          else {
            setData([]);
          }
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching trade data:', error);
      });

  };

  const columns = [

    { title: 'ACTION', data: 'action', id: 1 },
    { title: 'CLIENT', data: 'client' },
    { title: 'SYMBOL', data: 'script' },
    {
      title: 'ORDER TYPE',
      data: 'orderType',
      render: (data) => {
    
        return data.toUpperCase();
      },
    },
    { title: 'LOT', data: 'lot' },
    { title: 'QTY', data: 'quantity' },
    { title: 'ORDER PRICE', data: 'rate' },
    { title: status +' BY', data: 'by' },
    {
      title: 'USER IP',
      render: (data, type, full, meta) => {
        const ip = full.ip;
        if (!ip) return null; // If there's no IP, return null (nothing to display)

        // Create the anchor tag for the IP
        return `<a href="https://whatismyipaddress.com/ip/${ip}" target="_blank">${ip}</a>`;
      },
    }, { title: 'O-TIME', data: 'orderTime', className : 'text-nowrap' },

  ];

  return (
    <div className="container-fluid">
      <Card>
        <Card.Body>
          <Row>
            <Col sm={2} xl={1} >
              <div onChange={handleChange}>
                {['radio'].map((type) => (
                  <div key={`inline-${type}`}>
                    <Form.Check
                      inline
                      label="UPDATED"
                      className="fss-06"
                      name="group1"
                      type={type}
                      id={`inline-${type}-1`}
                      checked={status === 'UPDATE'}
                      onChange={() => setStatus('UPDATE')}

                    />
                  </div>
                ))}
                {['radio'].map((type) => (
                  <div key={`inline-${type}`}>
                    <Form.Check
                      inline
                      label="DELETED"
                      className="fss-06"
                      name="group1"
                      type={type}
                      id={`inline-${type}-1`}
                      checked={status === 'DELETE'}
                      onChange={() => setStatus('DELETE')}

                    />
                  </div>
                ))}
                {['radio'].map((type) => (
                  <div key={`inline-${type}`}>
                    <Form.Check
                      inline
                      label="INSERT"
                      className="fss-06"
                      name="group1"
                      type={type}
                      id={`inline-${type}-1`}
                      checked={status === 'INSERT'}
                      onChange={() => setStatus('INSERT')}
                    />
                  </div>
                ))}

              </div>
            </Col>

            <Col>
              <Row>
                <Col xs={12} sm={5} xl={3}>
                  <Row className="d-flex align-items-center">
                    <Col xs={6} sm={6}>
                      <b className="fss-05">FROM</b> <br />
                      <From fromDate={fromDate} onDateChange={handleFromDateChange} />
                    </Col>

                    <Col xs={6} sm={6} >
                      <b className="fss-05">TO</b><br />
                      <To toDate={toDate} setToDate={setToDate} />
                    </Col>
                  </Row>
                </Col>

                <Col xs={4} sm={5} xl={3}>
                  <b className='fss-05'>MARKET</b>
                  <MarketDropdown allScripts={allScripts} onMarketChange={handleMarketChange}
                    onScriptReset={handleScriptReset} />

                </Col>
                <Col xs={4} sm={5} xl={3}>
                  <b className='fss-05'>SCRIPT NAME</b>
                  <ScriptDropdown
                    allScripts={allScripts}
                    selectedMarket={selectedMarket}
                    onScriptChange={handleScriptChange}
                  />
                </Col>
                {user.adminType == 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER' ?
                  <>
                    <Col xs={4} sm={5} xl={3}>
                      <b className="fss-05">ADMIN</b>
                      <AdminDropdown
                        adminId={user.adminId}
                        setSelectedOption={setSelectedAdmin} />
                    </Col>
                  </> : ""}
                <Col></Col>
              </Row>
              <Row>

                {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'SUPER_MASTER' ?
                  <>
                    <Col xs={4} sm={5} xl={3}>
                      <b className="fss-05">MASTER</b>
                      <MasterDropdown
                        adminId={user.adminId}
                        selectedAdmin={selectedAdmin}
                        setSelectedOption={setSelectedMaster}
                        setSelectedMaster={setSelectedMaster}
                        setSelectedBrokerId={setSelectedBrokerId}
                      />
                    </Col>
                  </> : ""}

                {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'MASTER' || user.adminType == 'SUPER_MASTER' ?
                  <>
                    <Col xs={4} sm={5} xl={3}>
                      <b className="fss-05">BROKER</b>
                      <BrokerDropdown
                        selectedAdmin={selectedAdmin}
                        selectedMaster={selectedMaster}
                        setSelectedOption={setSelectedBrokerId}
                        setSelectedBrokerId={setSelectedBrokerId}
                        setSelectedSubBrokerId={setSelectedSubBrokerId}
                      />
                    </Col>
                  </> : ""}

              
                <Col xs={4} sm={5} xl={3}>
                  <b className="fss-05">CLIENT</b>
                  <ClientDropdown
                    selectedAdmin={selectedAdmin}
                    selectedMaster={selectedMaster}
                    selectedBrokerId={selectedBrokerId}
                    setSelectedOption={handleSelectedClientChange}
                  />
                </Col>
                <Col xs={6} sm={4} xl={3} className="mt-4">
                  <Button variant="success" size="sm" className="w-20 me-1" onClick={handleSubmit}>
                    SEARCH
                  </Button>
                  <Button variant="danger" size="sm" className="w-20" onClick={handleReset}>
                    RESET
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mt-2">
        <Card.Body>
          <div className="table-responsive">
            {loading ? (
              <div className="container vh-100">
                <div className="d-flex align-items-center justify-content-center h-90">
                  <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <DataTable className="mt-1 table  text-center  bg-secondary-row fss-08  table th"
                columns={columns}
                data={data}

                options={{
                  createdRow: function (row, data) {
                    if (data.orderType.includes("Buy")) {
                      $(row).addClass('buy-row');
                    } else if (data.orderType.includes("Sell")) {
                      $(row).addClass('sell-row');
                    }
                  },
                }}
              />
            )}
          </div>

        </Card.Body>
      </Card>
      <script src="https://cdnjs.cloudflare.com/ajax/libs/react/17.0.2/umd/react.production.min.js"></script>
      <script src="https://cdnjs.cloudflare.com/ajax/libs/react-dom/17.0.2/umd/react-dom.production.min.js"></script>
      <div id="react"></div>

    </div>
  )
}

export default Tradelog;
